import { Record as record } from 'immutable';

import WhitelistCustomer from './WhitelistCustomer';
import WhitelistClaimDetails from './WhitelistClaimDetails';
import Payment from '../Payment';
import { CompensationClaimType } from '../../../../src/constants/AppConstants';
import { getDefaults, getResolvers } from '../../../../src/helpers/Records';
import { construct, resolve } from '../../../../src/helpers/LinkMapper';

const fieldSchema = {
    "customer": [ resolve.as(WhitelistCustomer), new WhitelistCustomer() ],
    "claimDetails": [ resolve.as(WhitelistClaimDetails) ],
    "payment": [ resolve.as(Payment), new Payment() ]
};

export default class CompensationWhitelistClaim extends record(getDefaults(fieldSchema)) {
    static fromJSON(json = {}) {
        return construct(CompensationWhitelistClaim, json, getResolvers(fieldSchema));
    }

    get type() {
        return CompensationClaimType.WHITELIST;
    }
}
